<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width: 500px; max-width: 80vw;">
      <q-card-section>
        <div class="text-h6">Edit Building</div>
      </q-card-section>

      <q-card-section>
        <q-form @submit.prevent="handleSubmit">
          <q-select
            :model-value="formData.brick_class"
            :options="buildingBrickClasses"
            label="BRICK Class"
            filled
            required
            emit-value
            map-options
            class="q-mb-md"
            hint="Select the BRICK ontology class for this building"
            @update:model-value="$emit('update:brick-class', $event)"
          />
          <q-input
            :model-value="formData.name"
            label="Building Name"
            filled
            required
            class="q-mb-md"
            @update:model-value="$emit('update:name', $event)"
          />
          <q-input
            :model-value="formData.description"
            label="Description"
            filled
            type="textarea"
            rows="3"
            @update:model-value="$emit('update:description', $event)"
          />
        </q-form>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" @click="$emit('update:modelValue', false)" />
        <q-btn color="primary" label="Update Building" :loading="saving" @click="handleSubmit" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    modelValue: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    buildingBrickClasses: {
      type: Array,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:name',
    'update:brick-class',
    'update:description',
    'submit',
  ]);

  const handleSubmit = () => {
    emit('submit');
  };
</script>
